import React, {useEffect} from 'react'
import Page from "../Page";
import LoadingBanner from "../../components/LoadingBanner";
import TalentPortal from "../talent-portal/TalentPortal";
import OpportunityProposal from "../proposals/OpportunityProposal";
import {ProgressBar, Step} from "react-step-progress-bar";
import OppBriefStep from "./OppBriefStep";
import OpportunityDetails from "./OpportunityDetails";
import OppContractStep from "./OppContractStep";
import {TalentOppQuickSummary, TeamOppQuickSummary} from "./OppQuickSummary";
import {AuthContext} from "../../providers/AuthProvider";
import JobProfileSummaryModal from "../talent-job-board/components/JobProfileSummaryModal";
import EmptyBanner from "../../components/EmptyBanner";
import {useOpportunity} from "../../providers/OpportunityProvider";
import {Link, useNavigate} from "react-router-dom";

export default class OppDashboard extends Page {

    static contextType = AuthContext;

    static path = '/proposal';

    static title = 'Overview';

    static isLocked(opportunity) {
        return !opportunity.detailedViewAvailable()
    }

    static accomplishedForOpportunity(opportunity) {
        return true
    }

    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            isLoading: true,
            activeTab: "My Match Score",
            completedStep: 0,
            job: props.opportunity?.relatedJob(),
            progress: 0
        }
    }


    showJobProfileSummaryModal = async() => {
        await TB.event("Modal@hide");
        await TB.wait(500);
        return TB.event("Modal@show", {
            modalClass: "job-match-details-modal",
            content: (
                <JobProfileSummaryModal
                    disabled={this.props.isDisabled}
                    onRequestClose={() => TB.event("Modal@hide")}
                />
            )
        })
    }
    async componentDidMount()
    {
        super.componentDidMount();
        await this.promisedState({isLoading: false})
        await TB.wait(100);
        await this.promisedState({progress: this.props.opportunity?.getCurrentProgress()});

        if (!this.props.opportunity.canEditProposal()
            || this.props.opportunity.hasSubmittedProposal()
            || this.context?.auth?.isTalentSupplierResource())
        {
            return;
        }

        if (this.props.opportunity.isAccepted()) {
            await TB.sysAlert("talent.pursue_job_and_begin_proposal", undefined, {
                icon: "fas fa-thumbs-up"
            });
        } else if (this.props.opportunity.isInterested()) {
            await TB.sysAlert("talent.show_interest_and_begin_proposal")
        } else if (this.props.opportunity.isInvited()) {
            return;
            // await TB.sysAlert("talent.invited_and_begin_proposal");
        }

        return this.props.navigate({...this.props.location, search: "?proposal=1"}, {replace:true})
    }

    async onRequest(callback) {
        await this.promisedState({isDisabled: true});

        let result = await callback().catch(e => console.warn('ERROR: onRequest', e))

        await this.promisedState({isDisabled: false});

        return result;
    }

    async withdrawFromOpportunity() {
        let didWithdraw = await this.props.opportunity.withdrawInterest(
            this.props.onUpdate
        );
        if (!didWithdraw) {
            return;
        }

        await this.props.navigate({
            pathname: TalentPortal.projectsListPath(
                this.props.opportunity.displayStatus()
            )
        }, {replace: true});
    }

    tabs() {
        return [
            'My Match Score',
            'Cover Letter',
            'Availability & Rate'
        ]
    }

    getActiveIndex(step = this.state.activeTab) {
        return this.tabs().indexOf(step)
    }

    render() {

        let {
            opportunity,
            isDisabled
        } = this.props;

        let {
            isLoading
        } = this.state;

        const { auth } = this.context;

        let proposalNotSubmitted = !this.props.opportunity.hasSubmittedProposal()
        proposalNotSubmitted = false

        return (
            <div className="talent-opportunity-dashboard">

                {isLoading && <LoadingBanner message="Loading Proposal"/>}

                {!isLoading && (
                    proposalNotSubmitted ? (
                        <div className="flex-grow flex flex-center-col">
                            <EmptyBanner icon="fas fa-info-circle" message="Submit your proposal to view opportunity"/>
                        </div>
                    ) : (
                        <React.Fragment>
                            {opportunity.isBYO() ? (
                                <TalentOppQuickSummary
                                    job={opportunity.relatedJob()}
                                    opportunity={opportunity}
                                    isDisabled={isDisabled || isLoading}
                                />
                            ) : (
                                <TeamOppQuickSummary
                                    opportunity={opportunity}
                                    disabled={isDisabled || isLoading}
                                />
                            )}
                            <div className="flex flex-col items-stretch flex-grow p-3 p-md-4.5 gap-8 overflow-hidden">
                                <div className="opp-action-panels flex flex-row items-stretch gap-4 md:gap-2 flex-wrap lg:flex-nowrap">

                                    <div className={`opp-dashboard-panel opportunity-progress-info basis-full ${!auth.isTalentSupplierResource() ? 'xl:basis-1/3' : '' } `}>

                                        <div className="flex items-center">
                                            <h3 className="inline mb-0">
                                                Status
                                            </h3>

                                            {opportunity.can_be_withdrawn && (
                                                <button
                                                    className="btn btn-sm btn-primary withdraw-btn"
                                                    disabled={isDisabled}
                                                    onClick={this.withdrawFromOpportunity.bind(this)}
                                                >
                                                    Withdraw Interest
                                                </button>
                                            )}
                                        </div>

                                        {opportunity.isInterested() && !opportunity.isInvited() && (
                                            <div className="alert-dark w-100 justify-center">
                                                <p>
                                                    Waiting for client invite to shortlist
                                                </p>
                                            </div>
                                        )}

                                        {!opportunity.isInterested() && !opportunity.isAccepted() && (
                                            <div className="alert-dark w-full justify-center">
                                                <i className="fas fa-exclamation-circle mr-1"/>
                                                <p><i>Invited!</i></p>
                                                {opportunity.can_be_accepted ? (
                                                    <Link to={OpportunityDetails.pathForOpp(opportunity, OppBriefStep)}
                                                            className="btn py-0 btn-link">
                                                        Review Brief and Pursue
                                                    </Link>
                                                ) : (<p className="btn-link"/>)}
                                            </div>
                                        )}

                                        {!opportunity.isInterested() && opportunity.isAccepted() && opportunity.isProposing() && (
                                            <div className="alert-dark w-full justify-center">
                                                <i className="fas fa-exclamation-circle mr-1"/>
                                                <p><i>Pursued!</i></p>
                                                <span className="px-3">Next Awaiting Contract</span>
                                            </div>
                                        )}

                                        {opportunity.isAccepted() && opportunity.isPendingContract() && opportunity.hasContract() && !opportunity.hasSignedContract() && (
                                            <div className="alert-dark w-full justify-center">
                                                <i className="fas fa-exclamation-circle mr-1"/>
                                                <p><i>Selected!</i></p>
                                                <Link
                                                    to={OpportunityDetails.pathForOpp(opportunity, OppContractStep)}
                                                    className="btn py-0 btn-link">
                                                    Review Contract & Upload Signature
                                                </Link>
                                            </div>
                                        )}


                                        <div style={{ padding: '7px 38px' }}>
                                            <ProgressBar
                                                height={8}
                                                percent={this.state.progress}
                                                filledBackground={TB.config('color.primary')}
                                                unfilledBackground={TB.config('color.gray')}
                                            >
                                                {opportunity.progressSteps().map((step, index, arr) => (
                                                    <Step
                                                        key={step.shortName}
                                                        position={100 * (index / arr.length)}
                                                        children={({ accomplished }) => (
                                                            <div className="flex items-center flex-col" style={{ marginBottom: 20 }}>
                                                                <p className={TB.mapClass("opp-progress-label", { 'active': step.isActive })}>{step.shortName}</p>

                                                                <div
                                                                    className="progress-circle"
                                                                    style={{
                                                                        width: 20,
                                                                        height: 20,
                                                                        backgroundColor: accomplished ? TB.config('color.primary') : TB.config('color.gray'),
                                                                    }}
                                                                >
                                                                    {!accomplished && (
                                                                        <div
                                                                            className="progress-circle bg-white"
                                                                            style={{
                                                                                width: 9,
                                                                                height: 9,
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    />
                                                ))}
                                            </ProgressBar>
                                        </div>


                                    </div>

                                    {!auth.isTalentSupplierResource() && (
                                        <>
                                            <div className="opp-dashboard-panel flex-1 md:basis-1/3">
                                                <h3>Brief</h3>

                                                {opportunity.isInterested() ? (
                                                        <p className="empty-message">Not Invited Yet</p>
                                                    ) :
                                                    <div className="brief-document">
                                                        <Link to={OpportunityDetails.pathForOpp(opportunity, OppBriefStep)}
                                                            className="document-link">
                                                            <i className="far fa-file-alt"/>
                                                        </Link>

                                                        {opportunity.hasUnseenUpdate() && (
                                                            <span className="opp-unseen-update-panel">
                                                                <i className="fas fa-exclamation-circle"/>
                                                                Updated
                                                            </span>
                                                        )}

                                                        {opportunity.isAccepted() ? (
                                                            <div className="brief-status">
                                                                <i className="fas fa-check-circle text-success mr-1"/>
                                                                <p>
                                                                    Pursued: {TB.moment(opportunity.accepted_at).format('ll')}
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <div className="brief-status">
                                                                <i className="fas fa-exclamation-circle mr-1"/>
                                                                <p>
                                                                    Not Pursuing Yet
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                            <div className="opp-dashboard-panel flex-1 md:basis-1/3">
                                                <h3>Contract</h3>
                                                {!opportunity.isAccepted() && !opportunity.isPendingContract() && (
                                                    <p className="empty-message">No Contract Yet</p>
                                                )}
                                                {opportunity.isAccepted() && !opportunity.isPendingContract() && (
                                                    <p className="empty-message">Not Selected yet</p>
                                                )}
                                                {opportunity.isAccepted() && opportunity.isPendingContract() && !opportunity.hasContract() && (
                                                    <p className="empty-message">
                                                        Selected, Awaiting Contract
                                                    </p>
                                                )}
                                                {opportunity.isAccepted() && opportunity.isPendingContract() && opportunity.hasContract() && (
                                                    <div className="brief-document">
                                                        <Link
                                                            to={OpportunityDetails.pathForOpp(opportunity, OppContractStep)}
                                                            className="document-link">
                                                            <i className="fas fa-file-signature"/>
                                                        </Link>
                                                        {opportunity.hasSignedContract() ? (
                                                            <div className="brief-status">
                                                                <i className="fas fa-check-circle text-success mr-1"/>
                                                                <p>
                                                                    Completed
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <div className="brief-status">
                                                                <i className="fas fa-exclamation-circle mr-1"/>
                                                                <p>
                                                                    Needs Signature
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}

                                </div>
                                <div className="flex flex-col items-stretch gap-8">
                                    <h5 className="proposal-title">My Proposal</h5>

                                    <OpportunityProposal
                                        opportunity={opportunity}
                                        onRequest={this.props.onRequest}
                                        disabled={isDisabled || isLoading}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    )
                )}

            </div>
        );
    }

    componentWillUnmount() {
        TB.event("Modal@hide");
        super.componentWillUnmount();
    }
}


const OppDashboardTab = (props) => {

    const navigate = useNavigate();
    const {
        onRequest,
        onUpdate,
        opportunity,
        isDisabled
    } = useOpportunity();

    useEffect(() => {
        let middlewareCheck = async () => {
            if (opportunity && !opportunity.isOnHold() && !opportunity.isInterested() && !opportunity.isAccepted()) {
                await TB.sysAlert('talent.opportunity_prompt_needs_accept_brief')
                return navigate("../review-project-brief")
            }
        }

        middlewareCheck().catch(console.warn)
    });


    return (
        <OppDashboard navigate={navigate} onRequest={onRequest}
                      onUpdate={onUpdate}
                      opportunity={opportunity}
                      isDisabled={isDisabled}/>
    )
}

export {
    OppDashboardTab
}